import { ImportWriteMode } from "@fusion-advantage/backcompat"
import { RootRouteContentType } from "@fusion-advantage/formlib"
import { AppRootState } from "./appStore"
import { createSelector } from "@reduxjs/toolkit"

export const selectContentIsWritableForm = createSelector(
	(state: AppRootState) => state.app.content.type,
	(state: AppRootState) => state.render.form?.writeMode,
	(contentType, writeMode): boolean => {
		if(contentType !== RootRouteContentType.Form) {
			return false
		}
		if(writeMode === undefined || writeMode === ImportWriteMode.ReadOnly) {
			return false
		}
		return true
	}
)
